import { Injectable } from '@angular/core';
import { UserInitializationService } from '@meddev/fe-shared';
import { Store } from '@ngxs/store';
import { forkJoin, Observable } from 'rxjs';
import { BaseStateActions } from '../../../_common/state/base/base.actions';
import { MenuStateActions } from '../../../_common/state/menu/menu.actions';
import { AuthService } from './auth.service';

@Injectable({
    providedIn: 'root',
})
export class UserInitService extends UserInitializationService {
    constructor(
        private authService: AuthService,
        private store: Store,
    ) {
        super();
    }

    initializeUserData(tokenModel: any): Observable<unknown> {
        return this.authService.initializeUserData(tokenModel);
    }

    clearUserData(): Observable<unknown> {
        return forkJoin([this.store.dispatch(BaseStateActions.Common.ClearBaseState), this.store.dispatch([MenuStateActions.ClearHeaderData])]);
    }
}
